<template>
  <div id="content">
    <template v-if="live_classes.length">
      <div class="card card-tooltip" v-if="live_classes.class.length > 0">
        <div class="card-body">
          <div class="card-content" v-for="(live_class_item, index) in live_classes.class" v-if="index === 0">
            <div class="title">{{ live_class_item.subscribe_from | convertUnitToTime('ddd') }} -
              {{ live_class_item.subscribe_from | convertUnitToTime('DD/MM/YYYY') }} -
              {{ live_class_item.time_start | convertUnitToTime('HH:mm') }} {{ $t('to') }}
              {{ live_class_item.time_end | convertUnitToTime('HH:mm') }}</div>
            <p class="desc"><b>{{ $t('subject') }}: </b> <span class="underline">{{ live_class_item.subject }}</span></p>
            <template v-if="live_class_item.is_live == 1">
              <span class="live-class-dot"></span><span class="live-class-text">{{ $t('live_now') }}</span>
            </template>
            <div style="margin-top: 16px" v-if="live_class_item.is_live == 1">
              <button class="btn btn-join-class" style="padding: 4px 25px;  width: 100%" @click="join_class(live_class_item)">{{ $t('join_to_class') }}</button>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div class="container">
      <div class="card card-live-alert mt-20" style="margin-bottom: 20px" v-if="user_info.student_type == 1 && (live_classes.length > 0 || examinations.length > 0 || englishChampions.length > 0)">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">Thông báo học tập</span>
            <div class="buttons" style="margin-left: 15px">
              <div class="btn-group">
                <template v-for="tab in noticeTabs">
                  <button type="button" class="btn btn-default" :class="{ active: notice == tab.notice }" @click="changeNotice(tab.notice)">
                    {{ tab.title }}
                  </button>
                </template>
              </div>
            </div>
          </h5>
          <div class="card-content" style="background: #F8F8F8;">
            <div class="swiper mySwiper" v-if="notice == 'live_class'">
              <div class="swiper-wrapper" v-if="live_classes.length > 0">
                <div class="swiper-slide" v-for="(live_class_item, index) in live_classes.class">
                  <div class="card-live-alert-item">
                    <div class="title">{{ live_class_item.subscribe_from | convertUnitToTime('ddd') }} -
                      {{ live_class_item.subscribe_from | convertUnitToTime('DD/MM/YYYY') }} -
                      {{ live_class_item.time_start | convertUnitToTime('HH:mm') }} {{ $t('to') }}
                      {{ live_class_item.time_end | convertUnitToTime('HH:mm') }}
                      <template v-if="live_class_item.is_live == 1">
                        <span class="live-class-dot"></span><span class="live-class-text">{{ $t('live_now') }}</span>
                      </template>
                    </div>
                    <p class="desc"><b>{{ $t('class') }}: </b> <span class="underline">{{ live_class_item.class_name
                    }}</span></p>
                    <p class="desc"><b>{{ $t('subject') }}: </b> <span class="underline">{{ live_class_item.subject
                    }}</span></p>
                    <p class="desc"><b>{{ $t('teacher') }}: </b> <span class="underline">{{ live_class_item.teacher
                    }}</span></p>
                    <div style="margin-top: 16px" v-if="live_class_item.is_live == 1">
                      <button class="btn btn-join-class" style="padding: 4px 25px;  width: 100%" @click="join_class(live_class_item)">{{ $t('join_to_class') }}</button>
                    </div>
                  </div>
                </div>
                <div class="swiper-button-next">
                  <img src="/themes/ito/images/live-class-next.svg" alt="">
                </div>
                <div class="swiper-button-prev">
                  <img src="/themes/ito/images/live-class-prev.svg" alt="">
                </div>
              </div>
              <div style="padding: 42px 0; text-align: center; width: 100%;" v-else>
                No live class available. Try again later.
              </div>
            </div>
            <div class="swiper mySwiper" v-if="notice == 'examinations'">
              <template v-if="examinations">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(examination, index) in examinations">
                    <div class="card-live-alert-item">
                      <div class="title">
                        {{ $t('from') }} {{ examination.start }} {{ $t('to') }} {{ examination.end }}
                      </div>
                      <p class="desc"><b>{{ examination.name }}</b></p>
                      <p class="desc"><b>{{ $t('subject') }}: </b> <span class="underline">{{ examination.subject
                      }}</span></p>

                      <div style="margin-top: 16px">
                        <a :href="examination.url" target="_blank">
                          <button class="btn btn-join-class" style="padding: 4px 25px;  width: 100%">
                            {{ $t('btn_take_the_test') }}
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-button-next">
                  <img src="/themes/ito/images/live-class-next.svg" alt="">
                </div>
                <div class="swiper-button-prev">
                  <img src="/themes/ito/images/live-class-prev.svg" alt="">
                </div>
              </template>
              <div class="swiper-wrapper" v-else>
                <div style="padding: 42px 0; text-align: center; width: 100%;">No tests available. Try again later.
                </div>
              </div>
            </div>
            <div class="english_champions" v-if="notice == 'english_champions'">
              <template v-if="englishChampions.length">
                <template v-for="(examination, index) in englishChampions">
                  <div class="english_champions_left">
                    <div class="title">
                      {{ $t('from') }} {{ refomatDateTime(examination.start) }} {{ $t('to') }} {{ refomatDateTime(examination.end) }}
                    </div>
                    <p class="desc"><b>{{ examination.name }}</b></p>
                    <p class="desc"><b>{{ $t('ec_exam_desc') }}: </b> <span class="underline">{{ examination.subject
                    }}</span></p>
                    <div style="margin-top: 16px">
                      <button type="button" class="btn btn-wait-class" v-if="timeRemaining > 0" v-html="$t('ec_exam_open_in') + ':&n bsp;' + timeLeft"></button>
                      <a :href="examination.url" class="btn btn-join-class" target="_blank" v-else>
                        {{ $t('btn_do_ec_exam') }}
                      </a>
                    </div>
                  </div>
                  <div class="english_champions_right">
                    <img class="img-fluid" src="https://s3-ec.s3.ap-southeast-1.amazonaws.com/assets/ec-banner.png" :alt="examination.name">
                  </div>
                </template>
              </template>
              <div class="swiper-wrapper" v-else>
                <div style="padding: 42px 0; text-align: center; width: 100%;">No tests available. Try again later.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="filter-main">
        <ul class="box-filter d-flex">
          <li v-for="subject in subjectData" @click="selectSubject(subject)" :class="{ active: subject.id == selectedSubject.id }">
            {{ (subject.program == 'ismart' ? 'iSMART: ' : '') + subject.name }}
          </li>
        </ul>
      </div>

      <div class="card mt-20" v-if="selectedSubject.require_subject == 0">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{ selectedSubject.name }}</span>
            <div class="d-flex gap-3">
              <router-link :to="{ path: '/final-test/' + user_info.grade + '/' + selectedSubject.id }" class="ito-btn ito-btn-primary fw-bold" v-if="selectedSubject.show_final_test == 1">
                {{ $t('do_final_test') }}
              </router-link>

              <!-- <button class="ito-btn ito-btn-outline-primary" v-if="selectedSubject.show_final_test == 0">
                {{ $t('final_test_passed') }}
              </button> -->

              <router-link @click.native="handleGACustomEvent('IP1_W_1000', selectedSubject.id)" class="ebook-link" :to="{ path: '/ebook/' + selectedSubject.units[0].id }" target="_blank"
                v-if="user_info.account_type > 1 && selectedSubject.program == 'ismart' && selectedSubject.ebook != ''">
                <img src="/themes/ito/images/icons/ebook1.svg" style="margin-right: 5px;">
                {{ $t('ebook_digital') }}
              </router-link>

              <a :href="selectedSubject.revision_document_url" class="ebook-link ms-3" target="_blank" v-if="selectedSubject.revision_document_url">
                <img src="/themes/ito/images/icons/note.svg" style="margin-right: 5px;">
                {{ $t('revision_document') }}
              </a>
              <a href="#" class="ebook-link ms-3" @click="studyGuide(selectedSubject)" v-if="selectedSubject.study_guide_picture">
                <img src="/themes/ito/images/icons/help.svg" style="margin-right: 5px;">
                {{ $t('study_guide') }}
              </a>
              <!-- <div class="levels" style="margin-left: 15px; font-size: 16px" v-if="selectedSubject.program == 'Eng_Test_Prep'">
              {{ $t('level') }}: <b>{{ user_info.ge_level }}</b>
            </div> -->
            </div>


          </h5>
          <div class="card-content">
            <div class="last-study d-flex justify-content-between mb-5" v-if="selectedSubject.has_latest_lesson && selectedSubject.program != 'Eng_Test_Prep'">
              <div class=" last-study-image d-flex">
                <img :src="selectedSubject.latest_lesson.image" alt="" class="" width="210" height="130" />
                <div class="last-study-content">
                  <div class="last-study-name">
                    {{ selectedSubject.latest_lesson.name_unit }}: {{ selectedSubject.latest_lesson.title_unit }}
                  </div>
                  <div class="last-study-des">
                    {{ selectedSubject.latest_lesson.name_lesson }}: {{ selectedSubject.latest_lesson.title_lesson }}
                  </div>
                  <div class="d-flex">
                    <router-link :to="{ path: '/lesson/' + selectedSubject.latest_lesson.subject_id + '-' + selectedSubject.latest_lesson.unit_id + '-' + selectedSubject.latest_lesson.lesson_id, }" class="btn btn-ito-2-large mt-2">
                      {{ $t("continue_txt") }}
                    </router-link>
                  </div>
                </div>
                <span class="desc-time">
                  <b>{{ selectedSubject.latest_lesson.time_ago_txt }}</b>
                  <template v-if="selectedSubject.latest_lesson.time_txt">
                    {{ $t("at") }} {{ selectedSubject.latest_lesson.time_txt }}
                  </template>
                </span>
              </div>
            </div>

            <div class="row" v-if="selectedSubject.units">
              <template v-if="existsUnitItem(selectedSubject)">
                <template v-for="(unit) in selectedSubject.units">
                  <div class="col-sm-6 col-md-4 col-lg-3 mb-4" v-if="(selectedSubject.filter_type == 'all' || (selectedSubject.filter_type == 'incomplete' && unit.incomplete == 1)) && ((unit.upgrade_package != 0 && unit.status == 1) || unit.status != 1) ">
                    <div class="card card-hover">
                      <div :class="(unit.status == 1 || unit.status == 2) ? 'lock-unit' : ''"
                        @click="unit.status == 0 ? gotoUnit(selectedSubject.id, unit.id) : (unit.status == 2 ? unitIncomplete(unit.component_requirement) : ((user_info.student_type != 2) ? upgradeAccount(user_info.student_type) : ''))">
                        <img :src="unit.image" alt="" class="card-img-top rounded-top-md" />
                        <div class="card-body lession-content">
                          <h3 class="lession-name">
                            <span>{{ unit.title }}</span>
                            <div class="tooltiptext">{{ unit.title }}</div>
                          </h3>
                          <h4 class="lession-status">
                            {{ $t("complete") }} {{ unit.process }}
                            {{ $t("complete_of") }} {{ unit.total }}
                          </h4>
                        </div>
                        <img class="lock-image" src="themes/ito/images/icons/icon-lock-new.svg" v-if="unit.status == 1 || unit.status == 2" />
                      </div>
                    </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <h3 class="text-center text-no-record">
                  {{ $t("incomplete_empty") }}
                </h3>
              </template>

            </div>
            <h3 class="text-center text-no-record" v-else>
              {{ $t("incomplete_empty") }}
            </h3>
          </div>
        </div>
      </div>

      <div class="card mt-20" v-else-if="selectedSubject.require_subject == 1">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">{{ $t("english") }}</span>
          </h5>
          <div class="card-content-nopadding">
            <div class="d-flex float-right-box">
              <img src="/themes/ito/images/placement-test.png" style="width: 85px" />
              <div class="float-right-box-content">
                <p>{{ $t(selectedSubject.require_subject_text) }}</p>
                <div class="float-right-box-btn" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#PopupPlacementTest">
                  {{ $t("placement_test") }}
                </div>
              </div>
              <img src="/themes/ito/images/t3.png" />
            </div>

            <div class="modal fade" id="PopupPlacementTest" tabindex="-1" role="dialog" aria-labelledby="PopupPlacementTest" aria-hidden="true" style="display: none">
              <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 650px">
                <div class="modal-content box-shadow-main">
                  <div class="close-popup" data-bs-dismiss="modal"></div>
                  <h3 class="popup-title mb-20">
                    {{ $t("placement_test") }}
                  </h3>
                  <div class="d-flex quick-test-box">
                    <div class="quick-test-item">
                      <img src="/themes/ito/images/listening.svg" />
                      <div class="quick-test-title">
                        {{ $t("listening") }}
                      </div>
                      <ul class="quick-test-list">
                        <li>
                          <span class="fc">{{ $t("part") }}</span> 1: 5
                          {{ $t("scores") }}
                        </li>
                        <li>
                          <span class="fc">{{ $t("part") }}</span> 2: 3
                          {{ $t("scores") }}
                        </li>
                        <li>
                          <span class="fc">{{ $t("part") }}</span> 3: 2
                          {{ $t("scores") }}
                        </li>
                      </ul>
                    </div>
                    <div class="quick-test-item">
                      <img src="/themes/ito/images/reading.svg" />
                      <div class="quick-test-title">
                        {{ $t("reading") }} & {{ $t("listening") }}
                      </div>
                      <ul class="quick-test-list">
                        <li>
                          <span class="fc">{{ $t("part") }}</span> 1: 5
                          {{ $t("scores") }}
                        </li>
                        <li>
                          <span class="fc">{{ $t("part") }}</span> 2: 3
                          {{ $t("scores") }}
                        </li>
                        <li>
                          <span class="fc">{{ $t("part") }}</span> 3: 2
                          {{ $t("scores") }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="quick-test-bottom box-shadow-main d-flex mt-20">
                    <div class="quick-test-bottom-text">
                      <div class="txt-2-rows">
                        <div class="text-right d-inline-block left-title">
                          {{ $t("total") }}:
                        </div>
                        <div class="d-inline-block right-text">
                          22 {{ $t("scores") }}
                        </div>
                      </div>
                      <div class="txt-2-rows">
                        <div class="text-right d-inline-block left-title">
                          {{ $t("time_allowance") }}:
                        </div>
                        <div class="d-inline-block right-text">
                          14 {{ $t("minutes") }}
                        </div>
                      </div>
                    </div>
                    <div class="ito-btn-large btn-test mt-20">
                      {{ $t("test") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-20" v-else-if="selectedSubject.require_subject == 2">
        <div class="card-body">
          <h5 class="card-title">
            <span class="title">IGS-Bridge</span>
          </h5>
          <div class="card-content-nopadding">
            <div class="d-flex float-right-box">
              <img src="/themes/ito/images/t2.png" />
              <div class="float-right-box-content">
                <p>{{ $t(selectedSubject.require_subject_text) }}</p>
                <div class="float-right-box-btn" data-bs-toggle="modal" data-bs-target="#upgradeAccountModal">
                  {{ $t("upgrade_account") }}
                </div>
              </div>
              <img src="/themes/ito/images/t4.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="popupUnitIncomplete" tabindex="-1" role="dialog" aria-labelledby="popupUnitIncomplete">
      <div class="modal-dialog modal-dialog-centered popup-main-2" role="document">
        <div class="modal-content box-shadow-main" style="padding: 20px 10px 30px;">
          <h3 class="popup-title mb-20">{{$t('popup_unlock_pacing_title')}}</h3>
          <p class="txt-popup" v-html="popupUnlockPacingContent">

          </p>
          <div class="ito-btn-small active mt-3" data-bs-dismiss="modal" style="margin: auto">
            {{ $t('ok') }}
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="studyGuide" tabindex="-1" role="dialog" aria-labelledby="popupStudyGuide">
      <div class="modal-dialog modal-dialog-centered image-modal-xl" role="document">
        <div class="image-modal modal-content box-shadow-main p-0">
          <span class="image-modal-dissmiss" data-bs-dismiss="modal" title="Close"></span>
          <img :src="subjectStudyGuidePic" :alt="subjectName">
        </div>
      </div>
    </div>

    <div class="modal fade" id="PopupPlacement" tabindex="-1" role="dialog" aria-labelledby="PopupPlacement" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 650px">
        <div class="modal-content box-shadow-main p-3">
          <div class="close-popup" data-bs-dismiss="modal"></div>
          <h3 class="popup-title mb-20">{{ $t("placement_test") }}</h3>
          <div class="d-flex quick-test-box">
            <div class="quick-test-item">
              <img src="/themes/ito/images/listening.svg" />
              <div class="quick-test-title">{{ $t("listening") }}</div>
              <ul class="quick-test-list">
                <li>Part 1: 5 scores</li>
                <li>Part 2: 3 scores</li>
                <li>Part 3: 2 scores</li>
              </ul>
            </div>
            <div class="quick-test-item">
              <img src="/themes/ito/images/reading.svg" />
              <div class="quick-test-title">
                {{ $t("reading") }} & {{ $t("listening") }}
              </div>
              <ul class="quick-test-list">
                <li>Part 1: 5 scores</li>
                <li>Part 2: 3 scores</li>
                <li>Part 3: 2 scores</li>
              </ul>
            </div>
          </div>
          <div class="quick-test-bottom box-shadow-main d-flex mt-20">
            <div class="quick-test-bottom-text">
              <div class="txt-2-rows">
                <div class="text-right d-inline-block left-title">total:</div>
                <div class="d-inline-block right-text">22 scores</div>
              </div>
              <div class="txt-2-rows">
                <div class="text-right d-inline-block left-title">
                  Time allowance:
                </div>
                <div class="d-inline-block right-text">14 minutes</div>
              </div>
            </div>
            <div class="ito-btn-large btn-test mt-20">Test</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { soundClick } from "../utils/utils";
import { getAllUnit, getOnlineTestData, getECData, getLiveClass } from "../models/dashboard";
import { joinLiveClass } from "../models/tutoring";

let counter;

export default {
  name: "Welcome",
  data() {
    return this.initState();
  },

  computed: {
    user_info() {
      return this.$store.state.user_info;
    },

  },

  watch: {
    $route() {
      this.fetch();
      this.$nextTick(function () {
        this.initSwiper()
      });
    },
  },

  created() {
    this.$store.commit("setMenuActive", "home");
    this.$store.commit("setLoading", true);
    this.fetch();
    this.$store.commit("setLoading", false);
  },
  mounted() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.initSwiper()
      }, 100)
    });
  },

  methods: {
    initState() {
      return {
        popupUnlockPacingContent:'',
        isLoading: false,
        subjectData: [],
        examinations: [],
        englishChampions: [],
        live_classes: [],
        noticeTabs: [],
        notice: '',
        grade: '',
        prevUnit: '',
        selectedSubject: [],
        checkedSubjects: [],
        subjectStudyGuidePic: '',
        subjectName: '',
        timeRemaining: 0,
        timeLeft: 0,
      };
    },

    fetch() {
      this.getAllUnits();
      this.getStudyNotices();

      const grade = localStorage.getItem('grade')
      if (grade) {
        if (grade <= this.user_info.grade) {
          this.grade = grade
        } else {
          this.grade = this.user_info.grade
        }
      } else {
        this.grade = this.user_info.grade
      }
    },

    getAllUnits() {
      const that = this;
      const checkedSubjects = localStorage.getItem('checkedSubjects');
      const grade = localStorage.getItem('grade') ? localStorage.getItem('grade') : that.user_info.grade;
      const params = {
        grade: grade
      };
      that.grade = grade
      axios.all([getAllUnit(params)]).then(
        axios.spread((response) => {
          if (response.data.code != 0) {
            return;
          }
          that.subjectData = [];
          const subjects = response.data.results.subjects || [];
          subjects.forEach((sbj) => {
            // kiểm tra final test cần làm thay vì kiểm tra xem đã hoàn thành chưa
            sbj.show_final_test = 0;
            if (that.user_info) {
              if (that.user_info.final_test_grade) {
                that.user_info.final_test_grade.forEach(function (e) {
                  if (e.subject_id == sbj.subject_id && grade == e.grade) {
                    sbj.show_final_test = 1;
                  }
                })
              }

            }
            sbj.filter_type = 'all';
            sbj.units = sbj.units.sort((a, b) => {
              return a.order - b.order;
            })
            const units = sbj.units;
            sbj.has_latest_lesson = false

            if (sbj.latest_lesson.lesson_id) {
              units.forEach((unit) => {
                if (unit.id == sbj.latest_lesson.unit_id) {
                  sbj.has_latest_lesson = true
                }
              })
            }

            that.subjectData.push(sbj);
          })
          if (checkedSubjects) {
            var subject = this.subjectData.filter((sbj) => sbj.category_code == checkedSubjects);
            this.selectSubject(subject[0])
          } else {
            this.selectSubject(this.subjectData[0])
          }
        })
      );
    },

    selectSubject(subject) {
      if (!subject) return;

      this.selectedSubject = subject;
      this.checkedSubjects = subject.category_code;
      if (subject.latest_lesson.lesson_id) {
        this.latest_lesson = subject.latest_lesson
      } else {
        this.latest_lesson = []
      }
      localStorage.setItem('checkedSubjects', subject.category_code);
      localStorage.setItem('program', subject.program);

      window.boChatbot?.setContext('subject', subject.name)
      window.boChatbot?.deleteContext('unit')
      window.boChatbot?.deleteContext('lesson')
      window.boChatbot?.deleteContext('module')
    },

    join_class(tutoring) {
      const that = this;
      that.$store.commit("setLoading", true);
      joinLiveClass({
        id: tutoring.id
      }).then((response) => {
        that.$store.commit("setLoading", false);

        if (response.data.code != 0) {
          return;
        }

        $('#tutoringDetailJoinClassModal' + tutoring.id).modal("hide");

        window.open(response.data.results.link, '_blank');

        that.$emit('updateTutoring', 'join_class', tutoring, response.data.results);
      }).catch(({ response }) => {
        that.$store.commit("setLoading", false);
        console.error(response);
      });
    },

    existsUnitItem(subject) {
      let exists = false;

      subject.units.forEach((unit) => {
        if (subject.filter_type == 'all' || (subject.filter_type == 'incomplete' && unit.incomplete == 1)) {
          exists = true;
        }
      });
      return exists;
    },

    changeNotice(notice) {
      this.notice = notice;
      this.$nextTick(function () {
        var swiper = new Swiper(".mySwiper", {
          slidesPerView: 2,
          spaceBetween: 20,
          pagination: {
            el: ".swiper-pagination",
            type: "fraction",
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      });
    },
    async getStudyNotices(params = {}) {
      const that = this;
      let live_classes = await axios.all([getLiveClass(params)]).then(
        axios.spread((response) => {
          if (response.data.code != 0) {
            return [];
          }
          const live_classes = response.data.results || [];
          that.$store.commit("setLiveClasses", live_classes);
          return live_classes;
        })
      );
      params = {
        user_id: that.user_info.user_id,
        grade: that.user_info.grade,
      };
      let englishChampions = await axios.all([getECData(params)]).then(
        axios.spread((response) => {
          if (response.data.code != 200) {
            return [];
          }
          var results = response.data.results
          let timeRemaining = results.length ? results[0].time_remaining : 0
          if (timeRemaining > 0) {
            this.timeRemaining = timeRemaining
            this.timerCountdown(timeRemaining)
          }
          return results || [];
        })
      );
      let examinations = await axios.all([getOnlineTestData(params)]).then(
        axios.spread((response) => {
          if (response.data.code != 200) {
            return [];
          }
          return response.data.results || [];
        })
      );

      let tabs = [];
      if (live_classes.length > 0) {
        tabs.push({
          title: "Live Class",
          notice: "live_class",
        });
      }
      if (examinations.length > 0) {
        tabs.push({
          title: "Examinations",
          notice: "examinations",
        });
      }
      if (englishChampions.length > 0) {
        tabs.push({
          title: "English Champion",
          notice: "english_champions",
        });
      }
      that.noticeTabs = tabs;
      that.englishChampions = englishChampions;
      that.examinations = examinations;
      that.live_classes = live_classes;
      if (tabs.length > 0) {
        that.changeNotice(tabs[0].notice)
      }
    },
    refomatDateTime(dateTime) {
      var str = dateTime.split(' ')
      if (localStorage.lang == "vi") {
        return str[0] + ' ' + this.$i18n.t('days') + ' ' + str[1];
      } else {
        return dateTime
      }
    },

    getSoundClick() {
      soundClick();
    },

    upgradeAccount() {
      this.$store.dispatch('setShowUpgradePopup', true);
    },

    studyGuide(subject) {
      this.handleGACustomEvent('IP1_W_1001', subject.id);
      this.$store.commit("setLoading", true);
      this.subjectStudyGuidePic = subject.study_guide_picture;
      this.subjectName = subject.name;
      this.$store.commit("setLoading", false);
      $('#studyGuide').modal('show');
    },

    unitIncomplete(units) {
      const names = units.map(x => x.name);
      this.prevUnit = names.join(', ');
      var text = this.$t('popup_unlock_pacing_content')
      this.popupUnlockPacingContent = text.replace('%s', '<strong>' + this.prevUnit + '</strong>');
      $('#popupUnitIncomplete').modal('show');
    },

    doTest() {
      this.$store.dispatch('setShowUpgradePopup', false);
      this.$store.dispatch('setShowPlacementModalFlag', true);
    },


    gotoUnit(subject_id, unit_id) {
      var path = '';
      if (this.selectedSubject.program == 'Eng_Test_Prep') {
        path = '/prep/' + subject_id + '/' + unit_id + '/1';
        this.handleGACustomEvent('IP1_W_4000')
        this.$router.push({ path: path })

      } else {
        if (this.selectedSubject.category_code == 'math') {
          this.handleGACustomEvent('IP1_W_1009', subject_id)
        }
        else if (this.selectedSubject.category_code == 'science') {
          this.handleGACustomEvent('IP1_W_1010', subject_id)
        }
        path = '/unit/' + subject_id + '/' + unit_id + '/1';
        this.$router.push({ path: path })

      }
      this.handleGACustomEvent('IP1_W_1008', subject_id)
    },

    handleGACustomEvent(element, id) {
      var user_id = this.user_info.user_id || 0;
      var school_id_ref = parseInt(this.user_info.school_id_ref) || 0;
      var params = {
        'w_user_id': user_id
      };

      if (element == 'IP1_W_1008') {
        params['subject_id'] = id || 0;
        params[element] = user_id + '|' + id;
      }

      else if (element == 'IP1_W_4000' || element == 'IP1_W_1009' || element == 'IP1_W_1010') {
        params['school_id'] = school_id_ref
        params[element] = user_id + '|' + school_id_ref;
      }

      else {
        params['course_id'] = id || 0;
        params[element] = user_id + '|' + id;
      }
      gtag('event', element, params);
    },

    timerCountdown(time_remaining) {
      const self = this;
      let days = this.$i18n.t('days')
      let hours = this.$i18n.t('hours')
      let minutes = this.$i18n.t('minutes')
      let seconds = this.$i18n.t('second')

      counter = new Counter(time_remaining + 1, 1000);
      counter.onTick(function (time) {

        var timeLeft = ''
        if (time.date > 0) {
          timeLeft = '<strong>' + time.date + '</strong>' + ' ' + days + ' ';
        }
        if (time.hour > 0) {
          timeLeft += '<strong>' + time.hour + '</strong>' + ' ' + hours + ' ';
        }
        if (time.minute > 0) {
          timeLeft += '<strong>' + time.minute + '</strong>' + ' ' + minutes + ' ';
        }
        timeLeft += '<strong>' + time.second + '</strong>' + ' ' + seconds
        self.timeLeft = timeLeft
      });
      counter.onEnd(function () {
        self.timeRemaining = 0
      })
      counter.start();
    },

    initSwiper() {
      return new Swiper(".mySwiper", {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  },
};
</script>

<style scoped>
.ebook-link {
  display: inline-block;
  box-shadow: 0px 2px 0px 0px #ffffff33 inset;
  box-shadow: 4px 4px 0px 0px #0000000d;
  background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-align: center;
  color: #FFFFFF !important;
  padding: 8px 12px;
  width: fit-content;
  border-radius: 30px;
}

.sticky {
  position: fixed;
  width: 100%;
  top: 65px;
  margin: auto;
  left: 0;
  right: 0;
  transform: translateX(45px);
  z-index: 99;
}

.btn-class-final-passed {
  cursor: auto;
  border: 1px solid #00a3ff;
  box-sizing: border-box;
  border-radius: 30px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  color: #00a3ff;
}

.card-tooltip {
  position: fixed;
  left: 105px;
  top: 171px;
  overflow: inherit;
  width: 200px;
}

.card-tooltip::before {
  content: "";
  position: absolute;
  top: 18%;
  left: 0;
  margin-left: -12px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent #fff transparent transparent;
}

.english_champions {
  display: flex;
  background: #002880;
  box-shadow: 4px 4px 0px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
}

.english_champions_left {
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 12px 20px;
}

.english_champions_left .title {
  font-size: 14px;
  font-weight: 700;
  color: #F04923
}

.english_champions_left .desc {
  font-size: 12px;
  font-weight: 600;
  color: #FFFFFF;
}


.english_champions_right {
  width: 50%;
  display: flex;
  justify-content: end;
  align-items: center
}


.card-tooltip .live-class-dot {
  margin-left: 0;
}

.card-tooltip .title {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  letter-spacing: 0.02em;
  color: #00A3FF;
  margin-bottom: 4px;
}

.image-modal-dissmiss {
  position: absolute;
  right: 10px;
  top: 10px;
  content: url('/public/themes/ito/images/icons/image-modal-dissmiss.svg');
  user-select: none !important;
  -webkit-user-select: none;
  cursor: pointer;
}

.image-modal {
  border-radius: 8px;
  overflow: hidden;
}

.image-modal-xl {
  max-width: 1920px;
  width: 80%;
}

.card-hover {
  cursor: pointer;
}
</style>